import React, { useState } from 'react';
import './SignOutConfirmSheet.css';

function SignOutConfirmSheet({ isOpen, onConfirm, onCancel }) {
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signout-overlay" role="dialog" aria-modal="true" onClick={onCancel}>
      <div className="signout-sheet" onClick={e => e.stopPropagation()}>
        <div className="signout-drag-handle" aria-hidden="true" />

        <h3 className="signout-title">Sign out of your account?</h3>
        <p className="signout-sub">
          You'll continue using ChopMyShop as a guest.
          Your saved lists will still be here on this device.
        </p>

        <div className="signout-actions">
          <button
            className="signout-btn signout-btn--confirm"
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading
              ? <span className="signout-spinner" aria-hidden="true" />
              : 'Sign out'
            }
          </button>
          <button
            className="signout-btn signout-btn--cancel"
            onClick={onCancel}
            disabled={loading}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default SignOutConfirmSheet;
